import Clients from '../component/Clients';
import Services from '../component/Services';
import OurTopClientele from '../component/OurTopClientele';
import About from '../component/About';
function Home() {
    return (
        <>
            <Clients />
            <About />
            <OurTopClientele />
            <Services />
        </>
    );
}
export default Home;